angular.module('rjmNg.directives').directive "popoverScoot", [
  "$window"
  "$rootScope"
  ($window, $rootScope) ->
    restrict: "A"
    scope: {
      scootPosition: '@'
    }
    (scope, element, attrs) ->

      scootPosition = scope.$eval(attrs.scootPosition)
      popover = null

      scope.scootPopoverOver = (scootPosition) ->
        # This is just for the bootstrap popover
        # There really isn't a better hook for this since it's controlled by bs
        popover = element.parent().parent()
        # using switch so more cases can be added
        switch scootPosition
          when "bottom-left"
            scootBottomPopoverToTheLeft()

      scootBottomPopoverToTheLeft = () ->
        # reset scoot position
        scootPosition = undefined
        popover
          .css({ "left": "auto", "right": "-20px", "top": "calc(100% + 15px)"})
          .removeClass("bottom")
          .addClass("bottom-left popover-wide")

      $rootScope.$on "popover-shown", (event, args) ->
        if scootPosition is undefined
          return
        else
          scope.scootPopoverOver(scootPosition)
  ]
